import React, { Component, Fragment } from 'react';
import { graphql } from 'react-apollo';
import { Dropdown } from 'semantic-ui-react';
import { AllAffiliates } from '../../queries/AllAffiliates';

class AffiliateDropdown extends Component {
  state = {}

  render = () => {
    const { allAffiliates=[] } = this.props.data
    const affiliatesOptions = allAffiliates.map(affiliate => ({
          key: affiliate.id,
          value: this.props.useId ? affiliate.id : affiliate.name,
          text: affiliate.name
        }))
    const { useId, ...restProps } = this.props;
    return (
      <Fragment>
        <label>{this.props.label}</label>
        <Dropdown
          fluid
          selection
          search
          options={affiliatesOptions}
          loading={this.props.data && this.props.data.loading}
          {...restProps}
        />
      </Fragment>
    )
  }
}

const AffiliateDropdownWithData =
  graphql(AllAffiliates, {
    options: (props) => ({
      fetchPolicy: 'cache-first'
    })
  })(AffiliateDropdown);

export default AffiliateDropdownWithData;



// WEBPACK FOOTER //
// ./src/component/dropdowns/AffiliateDropdown.js